import { FC, HTMLInputTypeAttribute, InputHTMLAttributes, SVGProps, ReactNode, MouseEventHandler } from 'react';
import { Control, FieldValues, RegisterOptions, UseFormRegister } from 'react-hook-form';

export interface InputProps {
  id: string;
  onChange?: (value: string) => void;
  type?: HTMLInputTypeAttribute;
  placeholder?: string;
  required?: boolean;
  value?: string | number;
  name?: string;
  color?: ColorType;
  disabled?: boolean;
  readOnly?: boolean;
  rightIcon?: FC<SVGProps<SVGSVGElement>>;
  autoFocus?: boolean;
  helperText?: ReactNode;
  onMouseDown?: MouseEventHandler<HTMLInputElement>;
  rules?: RegisterOptions;
  control?: Control<FieldValues>;
  onClick?: () => void;
  selectedOption?: string;
  borderless?: boolean;
  icon?: FC<React.SVGProps<SVGSVGElement>>;
  bordercolor?: borderColorObjectType;
  hasLeftPadding?: boolean;
  twStyle?: string;
  wrapperStyle?: string;
  inputStyle?: string;
  testId?: string;
  inputTestId?: string;
  dropdownTestId?: string;
  isError?: boolean;
  supportText?: string;
  supportTextStyles?: string;
  // Native input attributes that are forwarded to the underlying <input> at
  // runtime (via `...rest` on the styled flowbite input) but were missing from
  // the type. Adding them here aligns the type with actual behavior; broader
  // migration to ui-ds-base is tracked separately.
  maxLength?: InputHTMLAttributes<HTMLInputElement>['maxLength'];
  minLength?: number;
  pattern?: string;
  inputMode?: InputHTMLAttributes<HTMLInputElement>['inputMode'];
  autoComplete?: string;
}
export interface FormLabelPropsType {
  label?: ReactNode;
  id?: string;
  children: ReactNode;
  disabled?: boolean;
  isFullWidth?: boolean;
}
export type ColorType = 'success' | 'failure';
export interface IFormValues {
  [x: string]: string;
}
export type RegisterType = UseFormRegister<IFormValues>;
export const borderColorObject = {
  gray: 'border-gray-300 focus-visible:border-gray-400 focus-visible:ring-gray-400 focus:border-gray-300 focus:ring-gray-300 focus:ring-2',
  primary:
    'border-primary-200 focus-visible:border-primary-300 focus-visible:ring-primary-300 focus:border-primary-300 focus:ring-primary-300',
  'neutral-100':
    'border-neutral-100 focus-visible:border-neutral-100 focus-visible:ring-neutral-100 focus:border-neutral-100 focus:ring-neutral-100',
  'neutral-90':
    'border-neutral-90 focus-visible:border-neutral-90 focus-visible:ring-neutral-90 focus:border-neutral-90 focus:ring-neutral-90',
};
export type borderColorObjectType = keyof typeof borderColorObject;
